module.exports = __webpack_public_path__ + "img/jcfajd1.59369985.png";